"use strict";

var _AsyncBoundary;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AsyncBoundary } from '@autoguru/suspense';
import { PageLoading } from '@autoguru/components/PageLoader';
import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LandingPage = /*#__PURE__*/lazy(async () => import('./LandingPage'));
const ClientSelectorPage = /*#__PURE__*/lazy(async () => import('./ClientSelectorPage'));
export const FleetClientPortalHomeRoutes = () => _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
  fallback: PageLoading,
  children: /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/",
      element: /*#__PURE__*/_jsx(LandingPage, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/home",
      element: /*#__PURE__*/_jsx(ClientSelectorPage, {})
    })]
  })
}));